"use strict"

class Social {
    constructor() {
        this.breakpoint = 790;
        this.stepIndex = 6;
        this.maxIndex = this.stepIndex;
    }

    init(socialSection) {
        if (socialSection) {
            const socialGrid = socialSection.querySelector('.social-item-grid');
            const xhttp = new XMLHttpRequest();
            const socialDataUrl = socialGrid.dataset.url;
            const loadButton = socialGrid.parentElement.querySelector(".social-load-more");
    
            xhttp.open('GET', socialDataUrl);
            xhttp.send(null);
            xhttp.onreadystatechange = (e) => {
                if (e.target.readyState === XMLHttpRequest.DONE) {
                    if (e.target.status === 200) {
                        this.socialData = JSON.parse(e.target.responseText);
                        this.socialData.slice(0, this.maxIndex).forEach((data, i) => this.placeSocialItem(socialGrid, data, i));
                        window.addEventListener('resize', () => this.replaceSocialItem(socialGrid));

                        if (this.maxIndex < this.socialData.length) {
                            loadButton.addEventListener("click", () => this.loadMoreSocialItem(socialGrid));
                        } else {
                            loadButton.parentElement.removeChild(loadButton);
                        }
                    }
                }
            }
        }
    }

    // Create the DOM structure of a social item. On desktop we have 3 columns.
    // On mobile we only need 1 column.
    createSocialItem(socialGrid, socialData) {
        const placeholder = socialGrid.querySelector(".social-item-placeholder");
        const socialItem = placeholder.cloneNode(true);

        socialItem.id = "";
        socialItem.classList.remove("social-item-placeholder");
        socialItem.querySelector("p.social-item-content").innerHTML = socialData.text;

        if (socialData.media.default !== "") {
            socialItem.querySelector("img.social-item-picture").src = socialData.media.default;
        } else {
            socialItem.removeChild(socialItem.querySelector("img.social-item-picture"));
        }

        socialItem.querySelector("span.social-item-footer-author").innerHTML = socialData.author;
        socialItem.querySelector("span.social-item-footer-date").innerHTML = socialData.date;

        return socialItem;
    }

    placeSocialItem(socialGrid, socialData, i) {
        const socialColumns = socialGrid.querySelectorAll(".social-item-column");
        const socialItem = this.createSocialItem(socialGrid, socialData);

        if (window.innerWidth > this.breakpoint) {
            // Desktop display: each element is placed in a column to create the metro grid effect
            socialColumns[i % 3].appendChild(socialItem);
        } else {
            // Mobile display: basic flex column
            socialColumns[0].appendChild(socialItem);
        }
    }

    // To reset the grid when changing between desktop and mobile
    replaceSocialItem(socialGrid) {
        const socialItems = socialGrid.querySelectorAll('.social-item-column > .social-item');

        socialItems.forEach((item) => item.parentNode.removeChild(item));
        // Replace item
        this.socialData.slice(0, this.maxIndex).forEach((data, i) => this.placeSocialItem(socialGrid, data, i));
    }

    loadMoreSocialItem(socialGrid) {
        const loadButton = socialGrid.parentElement.querySelector('.social-load-more');
        if (this.maxIndex < this.socialData.length) {
            this.socialData.slice(this.maxIndex, this.maxIndex + this.stepIndex).forEach((data, i) => this.placeSocialItem(socialGrid, data, i + this.maxIndex));
            this.maxIndex += this.stepIndex;
            if (this.maxIndex >= this.socialData.length) {
                if (loadButton) {
                    loadButton.parentElement.removeChild(loadButton);
                }
            }
        } 
    }
}

export default Social;


// WEBPACK FOOTER //
// ./src/scripts/components/Social.js